// All static phrases of UI should be present here as English - Us Language
// in future we can have files in other languages too
// please don't use textTransform properties on these phrases and Have the text as exactly it needs to be rendered.

export const content = {
    landingPage: {
        heading: "We give solutions to your",
        headingContent: ['pain disability', 'dysfunction', 'any musculoskeletal mechanical pain', 'misalignment'],
        banner: {
            title: "Upto 30% Discount for The First Comers",
            subTitle: "We’re glad you’re here. Let’s work together to restore strength, movement, and confidence."
        },
        chooseUsBanner: {
            title: "Why Choose Us",
            subTitle: "At Realign Healthcare, we are committed to helping you regain mobility, reduce pain, and improve your overall quality of life through expert physiotherapy care. Our highly qualified team creates personalized treatment plans tailored to your specific needs and goals, ensuring that each session is effective and meaningful. Using the latest equipment and evidence-based techniques, we provide hands-on, holistic care that focuses on long-term recovery and injury prevention. We pride ourselves on a patient-first approach — listening to your concerns, involving you in your treatment, and making your journey to better health as smooth and supportive as possible.",
            content: [
                {
                    title: "Happy Clients",
                    subTitle: "10K"
                },
                {
                    title: "Years of Experience",
                    subTitle: "19"
                },
                {
                    title: "Satisfaction",
                    subTitle: "100%"
                }
            ]

        },
        specialOffers: {
            title: "Our Special Offers",
        }
    },
    aboutPage: {
        heading: "About our",
        headingContent: ["company"],
        history: {
            title: "About Our History",
            content: "Our Journey to Realignment!",
            subContent: ["Founded with the mission to deliver integrative, evidence-based physiotherapy and osteopathy, Realign Healthcare began as a vision to address not just symptoms but the root causes of musculoskeletal pain. Our founder, Dr. Avijit Maji, combined traditional physiotherapy with advanced techniques in biomechanics and manual therapy to offer a truly personalized healing experience. Over the years, we've grown into one of Serampore’s most trusted centers for holistic rehabilitation.",
                "From the beginning, our approach has integrated modern physiotherapy, osteopathy, and manual techniques to treat the root cause of pain, not just the symptoms.",
                "With over a decade of service, Realign Healthcare has become a trusted name in Serampore, known for personalized care, advanced therapy techniques, and patient-first values."     ],
            points: ["Founded by Passion, Backed by Expertise", "Blending Science with Holistic Healing", "Growing Trust, One Patient at a Time"]
        },
        qualifications: [
                {
                    title: "Dr. Abhijit Maji (PT)",
                    description: "Consultant Physiotherapist | BPT, MPT (Orthopedic), APBC, FOMT (Osteopath)"
                },
                {
                    title: "Fellowships & Certifications",
                    description: "Fellowship in Shoulder and Knee (PSRP). Certified in Dry Needling, Neural Mobilization, Myokinetic, Mulligan Mobilization, Chiropractic, Pain Management by Hypnosis, Somatic Myofascial Chain Activations."
                },
                {
                    title: "Experience & Roles",
                    description: "19+ years experience, HOD Physiotherapy Dept., Shree Vishudhanand Hospital & WBHS."
                }
        ],
        ourStaffs: {
            title: "Our Staffs",
            subTitle: "Dedicated Team Behind Your Care!"
        }
    },
    blogPage: {
        heading: "Our",
        headingContent: ["blog updates"]
    },
    contactPage: {
        heading: "Get",
        headingContent: ["in touch with us"],
        formFields: {
            firstName: "First Name",
            lastName: "Last Name",
            email: "Email",
            subject: "Subject",
            message: "Message"
        },
        contactDetails: [
            { title: "Address", content: "82, G T Road, Bal Tala Serampore (Beside Khdaim's Showroom)" },
            { title: "Phone", content: "+91 9830425103" },
            { title: "Email Address", content: "drabhijitmaji@gmail.com" },
        ],
        moreInfo: {
            title: "More Info",
            content: "Find out the latest news about our Clinic Physiotheraphy & Osteopathy Clinic and information about all your Physiotheraphy and health-related needs. \n We are always happy to hear what you have to say so be sure to leave a comment."
        }
    },
    servicesPage: {
        heading: "We do our",
        headingContent: ["services to ease your pain"],
        ourServices:{
            title: "Our Services"
        }
    }
};
